import script from "./TeacherSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherSidebar.vue?vue&type=script&setup=true&lang=js"

import "./TeacherSidebar.vue?vue&type=style&index=0&id=ad1833ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad1833ba"]])

export default __exports__